import { render, staticRenderFns } from "./riOutAmend.vue?vue&type=template&id=f166f566&"
import script from "./riOutAmend.vue?vue&type=script&lang=js&"
export * from "./riOutAmend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports